module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"cvUserHelp":"Display the CV user list"},"ja":{"cvUserHelp":"CVユーザ一覧を表示"},"zh-hant":{"cvUserHelp":"顯示轉換使用者一覽"},"zh-hans":{"cvUserHelp":"显示转化用户一览"}}')
  delete Component.options._Ctor
}
